import { render, staticRenderFns } from "./ReactionAnimatedIcon.vue?vue&type=template&id=1012285a&scoped=true"
import script from "./ReactionAnimatedIcon.vue?vue&type=script&lang=js"
export * from "./ReactionAnimatedIcon.vue?vue&type=script&lang=js"
import style0 from "./ReactionAnimatedIcon.vue?vue&type=style&index=0&id=1012285a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1012285a",
  null
  
)

export default component.exports